import { createAction, props } from '@ngrx/store';
import { FormState } from './formFormateur.reducer';

export const loadForm = createAction('[FormFormateur] Load FormFormateur');

export const saveForm = createAction('[FormFormateur] Save FormFormateur');

export const updateForm = createAction(
    '[Form] Update FormFormateur',
    props<FormState>()
);

